<template>
  <router-view />
</template>

<script>
  export default {
    name: 'SupportIndex'
  }
</script>